import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IInfluencerCostRequest } from "@shared/lib/types/briefInfluencerV2";
import { BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY } from "../constants";
import { BriefService } from "../services/brief.service";

export function useAddInfluencerInitialCost(
  briefId: string,
  handleSuccess?: () => void
) {
  const {
    mutate: addInitialCost,
    isLoading: isAdding,
    isSuccess: isAdded,
  } = useMutation({
    mutationFn: (data: IInfluencerCostRequest) =>
      new Promise<any>((resolve, reject) => {
        BriefService.addIninitalInfluencerCost(data)
          .then((res) => {
            setTimeout(() => resolve(res), 1500);
          })
          .catch(async (err) => {
            const responseBody = await err.response.json().catch(() => ({}));
            ToastService.error(responseBody.msg || "An error occurred");
            setTimeout(() => reject(err), 2000);
          });
      }),
    options: {},
    onSuccess: (queryClient, data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });

      queryClient.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
      handleSuccess?.();
    },
  });

  return {
    addInitialCost,
    isAdding,
    isAdded,
  };
}
